import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Depot } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class DepotService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getDepot(id, schema: any = { id: null, name: null }): Promise<Depot> {
    return new Depot(await this.core.services.depot.getById(id, schema))
  }

  // todo vsude kde se pouzivalo this.core.lists.depots -> byly to depots s vyfiltrovanm userem !!! takze tam pridat posilaní filter do params
  async getDepots(
    parameters: any = {
      sort: 'name',
      direction: 'asc',
    },
    schema: any = { id: null, name: null }
  ): Promise<{
    items: Depot[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.depot.getList(parameters, schema)
  }

  getUserScopedDepots(allDepots: Depot[] = []): Depot[] {
    const userDepots = this.core.services.user.user?.depots ?? []
    if (!userDepots.length) {
      return allDepots
    }

    const allDepotIds = new Set(allDepots.map(depot => Number(depot.id)))
    return userDepots.filter(depot => !allDepotIds.size || allDepotIds.has(Number(depot.id)))
  }

  createDepot(depot: Partial<Depot>, schema: any): Promise<any> {
    return this.core.services.depot.create(depot, schema)
  }

  updateDepot(depot: Partial<Depot>, schema: any): Promise<any> {
    return this.core.services.depot.update(depot, schema)
  }

  deleteDepot(depot: Partial<Depot>): Promise<Partial<Depot>> {
    return this.core.services.depot.delete(depot)
  }

  doesUserHaveAllDepots(allDepots, userDepots?) {
    // console.log(allDepots)
    return allDepots?.length
      ? allDepots.every(depot => {
          return this.core.services.user.user?.depots.some(d => d.id === depot.id)
        })
      : []
  }
}
